import './popup.scss'
import { CmsLinkComponent } from '@omnia/ui/src/lib/cms/components/cmsLink/CmsLink'
import type { ImageWithFocalPointProps } from '@omnia/ui/src/lib/cms/components/ImageWithFocalPoint/ImageWithFocalPoint'
import { ImageWithFocalPoint } from '@omnia/ui/src/lib/cms/components/ImageWithFocalPoint/ImageWithFocalPoint'
import { Modal } from '@vista-digital/occ-ui/src/lib/subcomponents/modal/modal'
import type { FC } from 'react'
import { useState } from 'react'
import type { PopupPropsApi } from '@/common/components/popup/models'
import { MiniRichText } from '@/common/miniRichText/MiniRichText'

export interface PopupProps extends PopupPropsApi {
    id: number
}

const Popup: FC<PopupProps> = props => {
    const showedPopUpId = `showed-popup-${props.id}`
    const showedPopup = sessionStorage.getItem(showedPopUpId) === 'true'
    const [show, setShow] = useState<boolean>(!showedPopup)

    const imageSizes: ImageWithFocalPointProps = {
        ...props.headerMedia,
        dimensions: {
            width: 900,
            desktop: {
                width: 900,
            },
            tablet: {
                width: 800,
            },
            mobile: {
                width: 600,
            },
        },
    }

    const onClose = () => {
        sessionStorage.setItem(showedPopUpId, 'true')
        setShow(false)
    }

    return (
        <Modal className="popup" show={show} onClose={onClose}>
            <div className="popup__inner">
                <div className="popup__inner__text">
                    <div className="popup__inner__text__title">{props.title}</div>
                    <MiniRichText text={props.description} className="popup__inner__text__description" />
                    {props.link && (
                        <div>
                            <CmsLinkComponent link={props.link} className="popup__inner__text__cta">
                                <span className="popup__inner__text__cta__label">{props.link.name}</span>
                                <span>&#8594;</span>
                            </CmsLinkComponent>
                        </div>
                    )}
                </div>
                {imageSizes && (
                    <div className="popup__inner__image">
                        <ImageWithFocalPoint {...imageSizes} />
                    </div>
                )}
            </div>
        </Modal>
    )
}

export default Popup
